import React from "react";

import Page from "components/Page";
import DocumentFiles from "features/UploadFiles/documents";
import { i18n } from 'translate/i18n'
import {toast} from "react-toastify";
import {useNavigate} from "react-router";
import {useUser} from "../../store/providers/app";

const UploadDocuments = () => {

    const navigate = useNavigate();
    const { user } = useUser()

    if (user.profile !== 1) {
        toast.error('Você não tem permissão para acessar esta área!');
        navigate('/')
    }

    return (
        <Page label={i18n.t('titlePage.documents')} icon="bi bi-folder">
            <DocumentFiles
                types="application/*"
                param="documents"
            />
        </Page>
    );
}

export default UploadDocuments
